import { api } from './api';
import type { Ingredient, CreateIngredientInput, UpdateIngredientInput, IngredientFilters } from '../types';

export const ingredientService = {
  async getAll(filters?: IngredientFilters): Promise<Ingredient[]> {
    const params = new URLSearchParams();
    if (filters?.search) params.append('search', filters.search);
    if (filters?.category) params.append('category', filters.category);
    if (filters?.isVegetarian !== undefined) params.append('isVegetarian', String(filters.isVegetarian));
    if (filters?.isVegan !== undefined) params.append('isVegan', String(filters.isVegan));
    if (filters?.allergenId) params.append('allergenId', filters.allergenId);

    const queryString = params.toString();
    const url = queryString ? `/ingredients?${queryString}` : '/ingredients';
    
    const response = await api.get(url);
    return response.data;
  },

  async getById(id: string): Promise<Ingredient> {
    const response = await api.get(`/ingredients/${id}`);
    return response.data;
  },

  async create(data: CreateIngredientInput): Promise<Ingredient> {
    const response = await api.post('/ingredients', data);
    return response.data;
  },

  async update(id: string, data: UpdateIngredientInput): Promise<Ingredient> {
    const response = await api.put(`/ingredients/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/ingredients/${id}`);
  },

  async getStats() {
    const response = await api.get('/ingredients/stats');
    return response.data;
  },
};
